/**
 * Las fechas de la barra del calendario.
 *
 * Aquí van solo las que la PANTALLA necesita para moverse —el día de hoy, el mes
 * vecino, cómo se escribe un día—. La aritmética que coloca las cajas está en
 * `calendario-geometria.ts` y no se duplica: si algo de aquí calculara una
 * posición, estaría en el sitio equivocado.
 */
import { lunesDe } from './calendario-geometria'

export const hoyISO = (): string => new Date().toISOString().slice(0, 10)

/** Suma días a un `YYYY-MM-DD` sin tocar husos. */
export function sumarDias(dia: string, n: number): string {
    const d = new Date(`${dia}T00:00:00Z`)
    d.setUTCDate(d.getUTCDate() + n)
    return d.toISOString().slice(0, 10)
}

/** El día 1 del mes anterior. Al 1 y no al mismo número: el 31 de marzo menos un
 *  mes no existe en febrero, y `Date` lo desborda al 2 o 3 de marzo. */
export function mesAnterior(dia: string): string {
    const d = new Date(`${dia}T12:00:00Z`)
    d.setUTCDate(1)
    d.setUTCMonth(d.getUTCMonth() - 1)
    return d.toISOString().slice(0, 10)
}

export function mesSiguiente(dia: string): string {
    const d = new Date(`${dia}T12:00:00Z`)
    d.setUTCDate(1)
    d.setUTCMonth(d.getUTCMonth() + 1)
    return d.toISOString().slice(0, 10)
}

export function etiquetaDia(dia: string): string {
    return new Date(`${dia}T12:00:00Z`).toLocaleDateString('es-ES', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    })
}

/**
 * Cómo se nombra una semana (spec 015).
 *
 * `17 – 23 de agosto de 2026`, y cuando cruza de mes, `31 ago – 6 sep de 2026`.
 *
 * POR QUÉ NO «SEMANA DEL 17 DE AGOSTO»
 * ────────────────────────────────────
 * Porque una semana que empieza el 31 de agosto se llamaría «semana del 31 de
 * agosto» y **la mitad de lo que se ve es septiembre**. El propietario pidió
 * saber en qué mes se está; con el rótulo de antes, en esas semanas la respuesta
 * era medio falsa.
 *
 * El año va siempre: sin él, «17 – 23 de agosto» no dice de qué año, y un
 * calendario al que se llega por un enlace puede estar en cualquiera.
 */
export function rotuloSemana(dia: string): string {
    const l = new Date(`${lunesDe(dia)}T12:00:00Z`)
    const d = new Date(`${sumarDias(lunesDe(dia), 6)}T12:00:00Z`)
    const mismoMes = l.getUTCMonth() === d.getUTCMonth()
    const anio = d.getUTCFullYear()

    if (mismoMes) {
        const mes = l.toLocaleDateString('es-ES', { month: 'long' })
        return `${l.getUTCDate()} – ${d.getUTCDate()} de ${mes} de ${anio}`
    }
    const a = l.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })
    const b = d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })
    return `${a} – ${b} de ${anio}`
}
